import React from "react";

export default function Map(props) {
  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "grey",
        backgroundImage: `url(https://uploads.brevitybuilder.com/plugins/map.jpg)`,
        flexGrow: props.block.props.flexGrow,
        boxShadow: props.block.props.boxShadow,
        ...props.block.props.size,
        ...props.block.props.border,
        ...props.block.props.spacing,
      }}
      ref={props.editorRef}
    ></div>
  );
}
